const Footer = () => {
    return (
        <div className="footer py-2 text-center text-lighter">
            <div className="container">
               Asmaa Saad | All Rights Reserved &copy; 2024
            </div>
        </div>
    );
}

export default Footer;
